
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import './ComputerClasses.css';

// const courses = [
//     {
//         icon: '💻',
//         title: 'Basic Computer Course',
//         duration: '1 Month',
//         price: '₹1,500',
//         description:
//             'Learn computer fundamentals and essential computer skills.',
//         topics: [
//             'Computer Fundamentals',
//             'Hardware and Software',
//             'Windows and File Management',
//             'Keyboard and Mouse',
//             'Internet and Email',
//             'Basic Typing Skills',
//         ],
//     },
//     {
//         icon: '📊',
//         title: 'MS Office Course',
//         duration: '2 Months',
//         price: '₹3,000',
//         description:
//             'Learn essential office applications for study and work.',
//         topics: [
//             'MS Word',
//             'MS Excel',
//             'Excel Formulas',
//             'Tables and Charts',
//             'PowerPoint Presentations',
//             'Practical Assignments',
//         ],
//     },
//     {
//         icon: '📈',
//         title: 'Advanced Excel Course',
//         duration: '1 Month',
//         price: '₹2,500',
//         description:
//             'Develop practical Excel skills for office and business work.',
//         topics: [
//             'Advanced Excel Formulas',
//             'IF, SUMIF and COUNTIF',
//             'VLOOKUP and XLOOKUP',
//             'Sorting and Filtering',
//             'Pivot Tables and Charts',
//             'Reports and Projects',
//         ],
//     },
//     {
//         icon: '🌐',
//         title: 'Internet & Digital Skills',
//         duration: '15 Days',
//         price: '₹800',
//         description:
//             'Learn to use the internet and common digital services confidently.',
//         topics: [
//             'Internet and Browser Basics',
//             'Email Management',
//             'Online Forms and File Uploads',
//             'PDF and File Management',
//             'Digital Services',
//             'Online Safety',
//         ],
//     },
// ];

// function ComputerClasses() {
//     const navigate = useNavigate();

//     const handleEnquiry = (courseName, duration, price) => {
//         const phoneNumber = '919426944526';

//         const message =
//             `Hello A.P Tech Solutions!\n\n` +
//             `I am interested in the ${courseName}.\n` +
//             `Course Duration: ${duration}\n` +
//             `Course Fees: ${price}\n\n` +
//             `Please share more details about the course, batch timings and admission process.`;

//         const whatsappURL =
//             `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

//         window.open(whatsappURL, '_blank', 'noopener,noreferrer');
//     };

//     return (
//         <div className="computer-classes-page">
//             {/* Hero Section */}
//             <section className="computer-classes-hero">
//                 <span className="computer-classes-badge">
//                     A.P Tech Solutions
//                 </span>

//                 <h1>Computer Classes</h1>

//                 <p>
//                     Build your computer skills with practical training
//                     designed for students, beginners and professionals.
//                 </p>

//                 <button
//                     type="button"
//                     className="computer-classes-main-btn"
//                     onClick={() =>
//                         handleEnquiry(
//                             'Computer Classes',
//                             'Multiple options',
//                             'Please share course-wise fees'
//                         )
//                     }
//                 >
//                     Enquire on WhatsApp
//                 </button>
//             </section>

//             {/* Courses Section */}
//             <section className="computer-classes-section">
//                 <div className="computer-classes-heading">
//                     <h2>Explore Our Courses</h2>

//                     <p>
//                         Choose your course and contact us directly on
//                         WhatsApp for admission details.
//                     </p>
//                 </div>

//                 <div className="computer-classes-grid">
//                     {courses.map((course, index) => (
//                         <div
//                             className="computer-course-card"
//                             key={course.title}
//                         >
//                             <div className="computer-course-icon">
//                                 {course.icon}
//                             </div>

//                             <span className="computer-course-number">
//                                 Course {index + 1}
//                             </span>

//                             <h3>{course.title}</h3>

//                             <p className="computer-course-description">
//                                 {course.description}
//                             </p>

//                             {/* Duration and Price */}
//                             <div className="computer-course-details">
//                                 <div className="computer-course-detail-item">
//                                     <span>⏱️ Duration</span>
//                                     <strong>{course.duration}</strong>
//                                 </div>

//                                 <div className="computer-course-detail-item">
//                                     <span>💰 Course Fees</span>
//                                     <strong>{course.price}</strong>
//                                 </div>
//                             </div>

//                             <h4>What You Will Learn</h4>

//                             <ul>
//                                 {course.topics.map((topic) => (
//                                     <li key={topic}>
//                                         <span className="computer-topic-check">
//                                             ✓
//                                         </span>
//                                         {topic}
//                                     </li>
//                                 ))}
//                             </ul>

//                             <button
//                                 type="button"
//                                 className="computer-course-enquiry-btn"
//                                 onClick={() =>
//                                     handleEnquiry(
//                                         course.title,
//                                         course.duration,
//                                         course.price
//                                     )
//                                 }
//                             >
//                                 Enquiry on WhatsApp
//                                 <span> ↗</span>
//                             </button>
//                         </div>
//                     ))}
//                 </div>
//             </section>

//             {/* Contact Section */}
//             <section className="computer-classes-cta">
//                 <h2>Ready to Start Learning?</h2>

//                 <p>
//                     Contact A.P Tech Solutions for course information,
//                     batch timings and admission details.
//                 </p>

//                 <button
//                     type="button"
//                     className="computer-classes-main-btn"
//                     onClick={() =>
//                         handleEnquiry(
//                             'Computer Classes Admission',
//                             'As per selected course',
//                             'Please share course-wise fees'
//                         )
//                     }
//                 >
//                     Contact Us on WhatsApp
//                 </button>

//                 <button
//                     type="button"
//                     className="computer-classes-contact-btn"
//                     onClick={() => navigate('/Contact')}
//                 >
//                     Visit Contact Page
//                 </button>
//             </section>
//         </div>
//     );
// }

// export default ComputerClasses;







import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ComputerClasses.css';

const courses = [
    {
        icon: '💻',
        title: 'Basic Computer Course',
        duration: '1 Month',
        price: '₹1,500',
        description:
            'Learn computer fundamentals and essential computer skills.',
        topics: [
            'Computer Fundamentals',
            'Hardware and Software',
            'Windows and File Management',
            'Keyboard and Mouse',
            'Internet and Email',
            'Basic Typing Skills',
        ],
    },
    {
        icon: '📊',
        title: 'MS Office Course',
        duration: '2 Months',
        price: '₹3,000',
        description:
            'Learn essential office applications for study and work.',
        topics: [
            'MS Word',
            'MS Excel',
            'Excel Formulas',
            'Tables and Charts',
            'PowerPoint Presentations',
            'Practical Assignments',
        ],
    },
    {
        icon: '📈',
        title: 'Advanced Excel Course',
        duration: '1 Month',
        price: '₹2,500',
        description:
            'Develop practical Excel skills for office and business work.',
        topics: [
            'Advanced Excel Formulas',
            'IF, SUMIF and COUNTIF',
            'VLOOKUP and XLOOKUP',
            'Sorting and Filtering',
            'Pivot Tables and Charts',
            'Reports and Projects',
        ],
    },
    {
        icon: '🌐',
        title: 'Internet & Digital Skills',
        duration: '15 Days',
        price: '₹800',
        description:
            'Learn to use the internet and common digital services confidently.',
        topics: [
            'Internet and Browser Basics',
            'Email Management',
            'Online Forms and File Uploads',
            'PDF and File Management',
            'Digital Services',
            'Online Safety',
        ],
    },
];

function ComputerClasses() {
    const navigate = useNavigate();

    const handleEnquiry = (courseName, duration, price) => {
        const phoneNumber = '919426944526';

        const message =
            `Hello A.P Tech Solutions!\n\n` +
            `I am interested in the ${courseName}.\n` +
            `Course Duration: ${duration}\n` +
            `Course Fees: ${price}\n\n` +
            `Please share more details about the course, batch timings and admission process.`;

        const whatsappURL =
            `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappURL, '_blank', 'noopener,noreferrer');
    };

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    return (
        <div className="computer-classes-page">

            {/* Top Navigation Buttons */}
            <div className="computer-classes-top-nav">
                <button
                    type="button"
                    className="computer-classes-back-btn"
                    onClick={handleBack}
                >
                    ← Back
                </button>

                <button
                    type="button"
                    className="computer-classes-website-btn"
                    onClick={() => navigate('/Home')}
                >
                    🌐 Visit Website
                </button>
            </div>

            {/* Hero Section */}
            <section className="computer-classes-hero">
                <span className="computer-classes-badge">
                    NextZen IT Academy
                </span>

                <h1>Computer Classes</h1>

                <p>
                    Build your computer skills with practical training
                    designed for students, beginners and professionals.
                </p>

                <button
                    type="button"
                    className="computer-classes-main-btn"
                    onClick={() =>
                        handleEnquiry(
                            'Computer Classes',
                            'Multiple options',
                            'Please share course-wise fees'
                        )
                    }
                >
                    Enquire on WhatsApp
                </button>
            </section>

            {/* Courses Section */}
            <section className="computer-classes-section">
                <div className="computer-classes-heading">
                    <h2>Explore Our Courses</h2>

                    <p>
                        Choose your course and contact us directly on
                        WhatsApp for admission details.
                    </p>
                </div>

                <div className="computer-classes-grid">
                    {courses.map((course, index) => (
                        <div
                            className="computer-course-card"
                            key={course.title}
                        >
                            <div className="computer-course-icon">
                                {course.icon}
                            </div>

                            <span className="computer-course-number">
                                Course {index + 1}
                            </span>

                            <h3>{course.title}</h3>

                            <p className="computer-course-description">
                                {course.description}
                            </p>

                            {/* Duration and Price */}
                            <div className="computer-course-details">
                                <div className="computer-course-detail-item">
                                    <span>⏱️ Duration</span>
                                    <strong>{course.duration}</strong>
                                </div>

                                <div className="computer-course-detail-item">
                                    <span>💰 Course Fees</span>
                                    <strong>{course.price}</strong>
                                </div>
                            </div>

                            <h4>What You Will Learn</h4>

                            <ul>
                                {course.topics.map((topic) => (
                                    <li key={topic}>
                                        <span className="computer-topic-check">
                                            ✓
                                        </span>
                                        {topic}
                                    </li>
                                ))}
                            </ul>

                            <button
                                type="button"
                                className="computer-course-enquiry-btn"
                                onClick={() =>
                                    handleEnquiry(
                                        course.title,
                                        course.duration,
                                        course.price
                                    )
                                }
                            >
                                Enquiry on WhatsApp
                                <span> ↗</span>
                            </button>
                        </div>
                    ))}
                </div>
            </section>

            {/* Contact Section */}
            <section className="computer-classes-cta">
                <h2>Ready to Start Learning?</h2>

                <p>
                    Contact A.P Tech Solutions for course information,
                    batch timings and admission details.
                </p>

                <button
                    type="button"
                    className="computer-classes-main-btn"
                    onClick={() =>
                        handleEnquiry(
                            'Computer Classes Admission',
                            'As per selected course',
                            'Please share course-wise fees'
                        )
                    }
                >
                    Contact Us on WhatsApp
                </button>

                <button
                    type="button"
                    className="computer-classes-contact-btn"
                    onClick={() => navigate('/Contact')}
                >
                    Visit Contact Page
                </button>
            </section>
        </div>
    );
}

export default ComputerClasses;
